import type { GetDataPartnerOptionsQueryVariables } from '../../../../../../../graphql/query/audiences/GetDataPartnerOptions.generated';
import { US_REGION_CODE } from '../../../../constants';

export type MarketContext = {
  regionCode: string | null;
  countries: string[];
};

export const buildDataPartnerFilter = ({
  accountUid,
  marketContext,
}: {
  accountUid: string | undefined;
  marketContext?: MarketContext;
}): GetDataPartnerOptionsQueryVariables['filter'] => {
  const filter: Record<string, string | string[]> = {};

  if (accountUid) {
    filter.account_uid = accountUid;
  }

  if (marketContext) {
    const { regionCode } = marketContext;

    if (regionCode && regionCode !== US_REGION_CODE) {
      filter.region_codes = [regionCode];

      if (marketContext.countries.length > 0) {
        filter.country_codes = marketContext.countries;
      }
    }
  }

  return Object.keys(filter).length > 0 ? filter : undefined;
};
